import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';

/**
 * Which variables a field can use: a campaign's (project, campaign, influencer and general ones),
 * or only the system ones, for a system email that has no campaign or influencer.
 */
export type VariableScope = 'campaign' | 'systemic';

@Injectable({providedIn: 'root'})
export class VariableService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private variableUrl = this.baseApiUrl + '/api/v1/variable';

  list(params) {
    return this.http.get(`${this.variableUrl}`, {params});
  }

  /** The condition catalogue (operators, wording, limits, text syntax) the server renders by. */
  conditionSpec() {
    return this.http.get(`${this.variableUrl}/condition-spec`);
  }
}
